var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C2.010625 3.2475 3.02125 3.495 4.0625 3.75 C14.60924236 6.49945626 19.7950667 17.31380102 25 26 C25.70383966 27.15660767 26.40825662 28.31286426 27.11328125 29.46875 C30.4458888 34.96064152 33.70449589 40.49626507 36.96484375 46.03125 C46.83495845 62.78509029 56.81419206 79.46597621 67.25 95.875 C71.10872957 101.94904463 74.89342032 108.05927673 78.5625 114.25 C78.96823242 114.9291748 79.37396484 115.60834961 79.79199219 116.30810547 C85.76471555 126.4800035 88.9514715 136.17746395 85.9375 147.9375 C82.61935926 157.90742754 76.18718661 164.88185168 67.20703125 170.02734375 C60.31987914 173.21393652 51.62020503 173.21874261 44.37890625 171.30859375 C42.1048445 170.36665136 40.09087343 169.29666569 38 168 C37.31421875 167.5875 36.6284375 167.175 35.921875 166.75 C30.11986981 162.8524698 26.6939122 157.84188126 23 152 C22.11331748 150.62237251 21.22659599 149.24477011 20.33984375 147.8671875 C19.412462 146.41247742 18.48667954 144.95674655 17.5625 143.5 C16.88791748 142.43966553 16.88791748 142.43966553 16.19970703 141.35791016 C13 136.23614395 13 136.23614395 13 134 C12.34 134 11.68 134 11 134 C10.90460937 135.20011719 10.80921875 136.40023437 10.7109375 137.63671875 C9.97397201 144.17888122 8.31077106 150.45954548 6.625 156.8125 C6.45281952 157.46184509 6.28063904 158.11119019 6.10324097 158.7802124 C2.2078362 173.31842342 -3.1120237 187.14849233 -9 201 C-9.38800781 201.92490234 -9.77601563 202.84980469 -10.17578125 203.80273438 C-27.11915359 243.945954 -52.24407822 278.7534019 -80.6796875 311.45019531 C-81.59834559 312.5285314 -82.4981774 313.62307357 -83.3828125 314.72949219 C-84.54860551 316.18588126 -85.77006011 317.59736307 -87 319 C-87.66 319 -88.32 319 -89 319 C-89 319.99 -89 320.98 -89 322 C-90.22265625 323.296875 -90.22265625 323.296875 -92.0625 324.75 C-96.5671375 328.50926583 -100.68227196 332.5904866 -104.8125 336.75 C-105.47064697 337.41225586 -106.12879395 338.07451172 -106.80688477 338.75683594 C-108.00872223 339.96809292 -109.20968273 341.18022123 -110.40942383 342.39355469 C-110.93431396 342.92368164 -111.4592041 343.45380859 -112 344 C-112.51449707 344.52352051 -113.02899414 345.04704102 -113.55908203 345.58642578 C-115.60294903 347.59150709 -117.8303741 349.33287589 -120.0625 351.125 C-123.71509832 354.08617958 -127.24566384 357.10984229 -130.6875 360.3125 C-152.67961691 380.29271978 -179.16324472 396.53691423 -205 411 C-205.70060547 411.39429199 -206.40121094 411.78858398 -207.12304688 412.19482422 C-261.96244044 442.84267405 -324.65052309 457.61412415 -387 461 C-388.22525391 461.07202637 -389.45050781 461.14405273 -390.71289062 461.21826172 C-411.06928264 462.35249682 -430.74254177 461.54402147 -450.98168945 459.22851562 C-452.93157856 459.00774676 -454.88277081 458.79858285 -456.83398438 458.58984375 C-486.89744384 455.33204646 -516.35835529 448.6778981 -545 439 C-546.11213867 438.63181152 -547.22427734 438.26362305 -548.37011719 437.88427734 C-566.58573431 431.82010388 -583.76295178 424.38823156 -601 416 C-602.66524013 415.2015633 -604.33059103 414.40335756 -605.99609375 413.60546875 C-612.20545528 410.59894045 -618.16541867 407.46023366 -623.8203125 403.48046875 C-626.35098254 401.76160863 -628.96612217 400.2628098 -631.625 398.75 C-655.71757417 384.80486564 -678.08546361 367.36642024 -698.4140625 348.40234375 C-700.71829287 346.26170677 -703.0582698 344.18139785 -705.4375 342.125 C-708.42331594 339.5340027 -711.24059504 336.83398347 -714 334 C-714.928125 333.113125 -715.85625 332.22625 -716.8125 331.3125 C-719 329 -719 329 -719 327 C-719.66 327 -720.32 327 -721 327 C-722.375 325.63671875 -722.375 325.63671875 -724 323.6875 C-726.84002365 320.33697623 -729.75815152 317.09076071 -732.75 313.875 C-738.04206246 308.06976784 -742.87542717 301.96350175 -747.66064453 295.73779297 C-748.93041062 294.09029114 -750.21111954 292.45205966 -751.49609375 290.81640625 C-763.4074885 275.55076274 -774.0637286 259.61709774 -784 243 C-784.4134668 242.31115723 -784.82693359 241.62231445 -785.25292969 240.91259766 C-817.55179116 186.65436532 -817.55179116 186.65436532 -813.53515625 165.55859375 C-810.92371401 155.43732352 -804.67764384 148.46099859 -796.1171875 142.7421875 C-788.28968947 138.48617146 -778.12186793 138.52102275 -769.69921875 140.953125 C-756.13977233 146.75121034 -750.32072772 159.60343193 -744.6875 172.5 C-734.64284018 194.84747483 -722.98743482 216.53117884 -708 236 C-707.06730385 237.26080068 -706.1376137 238.52383062 -705.2109375 239.7890625 C-698.51216848 248.87313248 -691.48429158 257.55295517 -684 266 C-683.13761719 266.97453125 -682.27523437 267.9490625 -681.38671875 268.953125 C-677.18923457 273.66672362 -677.18923457 273.66672362 -672.75 278.1484375 C-671 280 -671 280 -671 282 C-670.443125 282.20625 -669.88625 282.4125 -669.3125 282.625 C-666.74687461 284.15050699 -665.30151891 285.99392319 -663.4609375 288.30859375 C-661.28903349 290.82312433 -658.79757743 292.89092679 -656.26953125 295.0390625 C-653.8026719 297.17049692 -651.44048199 299.39496529 -649.0625 301.625 C-624.7959505 323.71592782 -596.2213417 340.87247083 -567.0625 355.625 C-565.77460571 356.28218018 -565.77460571 356.28218018 -564.46069336 356.95263672 C-563.66026611 357.35240723 -562.85983887 357.75217773 -562.03515625 358.1640625 C-560.97373413 358.69700928 -560.97373413 358.69700928 -559.89086914 359.24072266 C-557.87561301 360.18631491 -557.87561301 360.18631491 -555 360 C-555 360.66 -555 361.32 -555 362 C-553.76378906 362.39703125 -552.52757812 362.7940625 -551.25390625 363.203125 C-546.49321607 364.78909317 -541.84634701 366.61051414 -537.18457031 368.46411133 C-478.57044967 391.67618452 -414.41723198 398.92361597 -352 390 C-351.00178223 389.86078125 -350.00356445 389.7215625 -348.97509766 389.578125 C-287.43907289 380.70066208 -230.50279315 353.39751092 -182 315 C-181.32404785 314.46536133 -180.6480957 313.93072266 -179.95166016 313.37988281 C-171.72607782 306.84261972 -163.72283009 300.12781268 -156 293 C-154.99195253 292.09386355 -153.98277657 291.18898141 -152.97265625 290.28515625 C-147.95068716 285.77300018 -143.09179248 281.24578332 -138.75 276.05859375 C-136.70215685 273.64963541 -134.53847431 271.36812567 -132.375 269.0625 C-126.26673837 262.36762178 -120.84836864 255.17438816 -115.43212891 247.91552734 C-114.26067082 246.34865722 -113.07560721 244.79196727 -111.88671875 243.23828125 C-87.38572616 210.65773222 -66.9802889 171.64198667 -57 132 C-57.48210938 132.433125 -57.96421875 132.86625 -58.4609375 133.3125 C-59.09257813 133.869375 -59.72421875 134.42625 -60.375 135 C-61.00148438 135.556875 -61.62796875 136.11375 -62.2734375 136.6875 C-64 138 -64 138 -66 138 C-66.23847656 138.5671875 -66.47695313 139.134375 -66.72265625 139.71875 C-70.73871508 146.89116088 -78.27819284 152.03433831 -86.0078125 154.41015625 C-95.25810204 156.23364675 -103.88634829 156.03768317 -112 151 C-113.04607422 150.36384766 -113.04607422 150.36384766 -114.11328125 149.71484375 C-121.77186204 144.53700853 -126.23865792 137.35919765 -128.52734375 128.46484375 C-130.24472821 119.50889667 -128.33431618 111.96419936 -123.890625 104.015625 C-118.70761806 96.52905943 -111.48246711 90.34460469 -105 84 C-102.33432156 81.37556272 -99.86679445 78.8368232 -97.5 75.9375 C-95 73 -95 73 -92.625 71.125 C-90.4093163 69.33135129 -88.84163511 67.71733875 -87.02734375 65.55859375 C-82.28068315 60.0729024 -77.09916614 55.02689077 -71.9375 49.9375 C-64.43387594 42.616877 -64.43387594 42.616877 -57.44140625 34.81640625 C-56.63574219 33.88699219 -55.83007812 32.95757812 -55 32 C-54.34 32 -53.68 32 -53 32 C-52.75846191 31.43466553 -52.51692383 30.86933105 -52.26806641 30.28686523 C-49.61883897 25.50917687 -45.21686265 21.89062208 -41.375 18.0625 C-40.49714844 17.16853516 -39.61929688 16.27457031 -38.71484375 15.35351562 C-29.71885877 6.35084715 -22.33106719 0.95736232 -9.25 0.8125 C-5.79525914 0.8325857 -3.28365756 0.90544748 0 2 C0 1.34 0 0.68 0 0 Z M-57 130 C-56 132 -56 132 -56 132 Z ",
    fill: "#FEFEFE",
    transform: "translate(924,466)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.56122589 0.00273422 1.56122589 0.00273422 3.1539917 0.00552368 C31.80879759 0.08944394 59.5655637 2.97855632 87.75 8.3125 C88.91837402 8.52745117 90.08674805 8.74240234 91.29052734 8.96386719 C110.08540209 12.46972839 127.78850085 17.89214886 145.75 24.3125 C146.60078125 24.61188477 147.4515625 24.91126953 148.328125 25.21972656 C157.51237637 28.45910194 166.40865603 32.27746975 175.2734375 36.296875 C178.22309248 37.63377822 181.18393507 38.93560758 184.1640625 40.203125 C196.41667398 45.41938898 196.41667398 45.41938898 201.671875 48.9609375 C204.41298636 50.74369038 207.26579848 52.28873066 210.125 53.875 C227.2031908 63.4951705 243.4108759 75.13506332 258.75 87.3125 C260.5536272 88.73320489 262.35868389 90.15207811 264.1640625 91.57055664 C265.4029788 92.54419572 266.64128859 93.51860719 267.87890625 94.49389648 C271.32910634 97.21125143 271.32910634 97.21125143 274.85546875 99.828125 C277.3645217 101.79398092 279.51000055 104.04587351 281.75 106.3125 C283.76391686 108.17503519 285.78446812 110.02806436 287.8125 111.875 C297.01603 120.33524892 305.82037471 128.86557967 313.609375 138.671875 C315.71606713 141.27064121 317.91945184 143.72912612 320.1875 146.1875 C325.4244555 151.9445016 330.10230063 158.07839103 334.75 164.3125 C335.45253906 165.25351563 336.15507813 166.19453125 336.87890625 167.1640625 C341.13815024 172.94863261 345.15932705 178.86383964 349.0859375 184.87890625 C350.66864189 187.35418947 350.66864189 187.35418947 352.75 189.3125 C353.97164232 191.33392254 355.15255122 193.3800555 356.3125 195.4375 C356.66473633 196.06148682 357.01697266 196.68547363 357.37988281 197.32836914 C358.12902206 198.6561937 358.87687307 199.98474575 359.62353516 201.31396484 C360.69242988 203.21036107 361.77200073 205.10018261 362.85546875 206.98828125 C393.43025588 260.46079547 393.43025588 260.46079547 389.1015625 279.10546875 C385.40552646 289.29326039 379.24803849 294.59330503 369.6171875 299.18359375 C360.86966321 302.62778247 352.30168687 301.93471132 343.75 298.3125 C334.91030119 293.1403358 329.43839102 285.47138109 324.875 276.5 C324.45154297 275.68265381 324.02808594 274.86530762 323.59179688 274.02319336 C319.89491058 266.79639033 316.56011172 259.42363775 313.34375 251.97265625 C300.79148902 223.14552747 280.22944864 194.10143648 257.0625 172.7578125 C255.75 171.3125 255.75 171.3125 255.75 169.3125 C254.76 168.9825 253.77 168.6525 252.75 168.3125 C252.75 167.6525 252.75 166.9925 252.75 166.3125 C251.7909375 165.9103125 251.7909375 165.9103125 250.8125 165.5 C248.75 164.3125 248.75 164.3125 247.75 161.3125 C246.42151037 160.63623265 245.08698864 159.97180539 243.75 159.3125 C241.92153864 157.70764304 240.13460818 156.05506425 238.375 154.375 C222.77807943 139.77192972 205.04369507 127.9018609 186.93457031 116.67285156 C185.01815851 115.47948471 183.11227667 114.27185355 181.2109375 113.0546875 C165.24809772 102.95413131 147.77034051 95.23801332 130.3359375 88.046875 C129.52946777 87.71397461 128.72299805 87.38107422 127.89208984 87.03808594 C125.65337067 86.15208867 125.65337067 86.15208867 122.75 86.3125 C122.75 85.6525 122.75 84.9925 122.75 84.3125 C122.069375 84.15394531 121.38875 83.99539062 120.6875 83.83203125 C114.81512906 82.41860154 109.05644256 80.80153373 103.3125 78.9375 C69.09827514 68.02035241 30.70339923 62.48947213 -5.25 64.3125 C-6.85053223 64.39226074 -6.85053223 64.39226074 -8.48339844 64.47363281 C-85.35334117 68.57252229 -161.8289083 94.23769254 -221.25 144.3125 C-222.11189941 145.03445557 -222.11189941 145.03445557 -222.99121094 145.77099609 C-227.12042576 149.23646798 -231.19800905 152.75720471 -235.25 156.3125 C-235.79946289 156.79203125 -236.34892578 157.2715625 -236.91503906 157.765625 C-238.47102234 159.12792906 -240.01839955 160.49925384 -241.5625 161.875 C-242.44550781 162.66003906 -243.32851563 163.44507813 -244.23828125 164.25390625 C-246.46666004 166.23433993 -246.46666004 166.23433993 -247.25 169.3125 C-250.69444444 172.3125 -250.69444444 172.3125 -253.25 172.3125 C-253.51683594 172.90933594 -253.78367188 173.50617188 -254.05859375 174.12109375 C-255.27486932 176.35824324 -256.45357259 177.65670067 -258.3125 179.375 C-262.53399339 183.49268618 -266.20718792 187.95947716 -269.86914062 192.57666016 C-270.84984365 193.8094746 -271.83610892 195.03787334 -272.82617188 196.26318359 C-303.22565456 233.91109784 -325.22880421 279.49918947 -337.25 326.3125 C-336.77691406 325.88839844 -336.30382812 325.46429688 -335.81640625 325.02734375 C-333.64499639 323.10143442 -331.45265779 321.20259366 -329.25 319.3125 C-328.16912109 318.38050781 -328.16912109 318.38050781 -327.06640625 317.4296875 C-319.14829127 310.90888693 -311.66234452 307.51096792 -301.265625 307.9375 C-290.77774031 309.24169292 -283.25740505 314.07828071 -276.6875 322.2578125 C-272.13554702 328.95026718 -269.28868785 337.21001184 -270.25 345.3125 C-273.22602808 360.39104227 -283.67318739 368.8909025 -294.234375 379.39453125 C-295.26350675 380.42179054 -296.29241249 381.4492763 -297.32110596 382.47697449 C-299.9998305 385.15192613 -302.68154235 387.82386226 -305.36395264 390.49511719 C-308.09212317 393.2130081 -310.81742654 395.93377069 -313.54296875 398.65429688 C-318.33471595 403.43654033 -323.12891984 408.21630624 -327.92498779 412.99421692 C-328.69224182 413.75925034 -329.45949585 414.52428375 -330.25 415.3125 C-331.58191376 416.62458687 -331.58191376 416.62458687 -332.94073486 417.96318054 C-335.26082273 420.20925665 -335.26082273 420.20925665 -336.9375 422.625 C-337.370625 423.181875 -337.80375 423.73875 -338.25 424.3125 C-338.91 424.3125 -339.57 424.3125 -340.25 424.3125 C-340.25 424.9725 -340.25 425.6325 -340.25 426.3125 C-341.60546875 427.609375 -341.60546875 427.609375 -343.4375 429.0625 C-345.93658083 431.11640044 -348.05487614 433.15092136 -350.0625 435.6875 C-350.784375 436.55375 -351.50625 437.42 -352.25 438.3125 C-352.91 438.3125 -353.57 438.3125 -354.25 438.3125 C-354.50523437 438.89257812 -354.76046875 439.47265625 -355.0234375 440.0703125 C-360.73420571 450.50974229 -372.25030141 457.08902338 -383.25 460.3125 C-391.81957139 462.64965583 -400.75552841 459.44051552 -408.43359375 455.47265625 C-420.46588849 447.78751316 -427.00062616 432.80355394 -434.015625 420.8125 C-436.93038787 415.8376008 -439.89993461 410.90084625 -442.9375 406 C-443.55226196 404.9958606 -443.55226196 404.9958606 -444.17944336 403.97143555 C-446.16349051 400.58119494 -446.16349051 400.58119494 -449.25 398.3125 C-449.60661174 396.98520314 -449.9354528 395.65038974 -450.25 394.3125 C-450.99634708 392.75546855 -451.79197851 391.22161001 -452.62109375 389.70703125 C-453.10787598 388.81467773 -453.5946582 387.92232422 -454.09619141 387.00292969 C-454.88388916 385.57835449 -454.88388916 385.57835449 -455.6875 384.125 C-456.22810059 383.14047852 -456.76870117 382.15595703 -457.32568359 381.14160156 C-460.58857628 375.22910586 -463.92886098 369.36988242 -467.375 363.5625 C-487.04350677 330.37388074 -487.04350677 330.37388074 -485.25 315.3125 C-482.6969943 305.66274632 -475.7259741 298.6460303 -467.43359375 293.5 C-459.83669843 289.3685936 -451.47621521 289.25503474 -443.25 291.4375 C-427.85210876 296.65876296 -421.56240365 307.52028949 -413.42431641 320.7487793 C-412.68060791 321.95207886 -412.68060791 321.95207886 -411.921875 323.1796875 C-411.4794043 323.90269043 -411.03693359 324.62569336 -410.58105469 325.37060547 C-409.28897517 327.25563857 -407.91851503 328.7582752 -406.25 330.3125 C-406.12238281 329.15234375 -405.99476563 327.9921875 -405.86328125 326.796875 C-402.34978499 299.05299783 -390.21282318 269.35723246 -378.25 244.3125 C-377.8998584 243.57741211 -377.5497168 242.84232422 -377.18896484 242.08496094 C-375.26968154 238.0921908 -373.28104255 234.1407848 -371.234375 230.21191406 C-370.23408513 228.28179125 -369.25690796 226.34111077 -368.28125 224.3984375 C-359.09398793 206.33146416 -348.18087636 189.16404233 -335.70605469 173.19677734 C-334.18590893 171.22955987 -332.70247578 169.2388689 -331.2265625 167.23828125 C-320.74706052 153.03579831 -309.52599831 139.36602896 -296.90234375 127 C-295.2333069 125.29545173 -293.71666035 123.51791638 -292.1875 121.6875 C-288.68808548 117.62625288 -284.84665309 113.9724068 -280.9375 110.3125 C-280.31415771 109.72388184 -279.69081543 109.13526367 -279.04858398 108.52880859 C-274.49305363 104.3125 -274.49305363 104.3125 -272.25 104.3125 C-272.25 103.6525 -272.25 102.9925 -272.25 102.3125 C-270.625 100.82421875 -270.625 100.82421875 -268.25 99 C-265.023494 96.49300936 -261.82447352 93.97463464 -258.69140625 91.3515625 C-248.6515326 82.97469589 -238.15579205 75.51685897 -227.25 68.3125 C-226.60788574 67.88453125 -225.96577148 67.4565625 -225.30419922 67.015625 C-216.94146504 61.45100793 -208.36036028 56.35294296 -199.53466797 51.55761719 C-197.96728769 50.70341336 -196.40399589 49.84167734 -194.84423828 48.97363281 C-153.80907387 26.19305284 -109.13742505 12.46351976 -62.9375 5.0625 C-62.16146423 4.93725952 -61.38542847 4.81201904 -60.58587646 4.6829834 C-40.39495698 1.45804859 -20.44795887 -0.0749664 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(509.25,69.6875)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.70530374 7.89550325 13.03873255 17.71401134 14.34765625 29.87109375 C14.94943906 36.65608009 14.85033779 43.44699893 14.6875 50.25 C15.5228125 50.34152344 16.358125 50.43304688 17.21875 50.52734375 C21.23589339 51.36424862 24.57858746 52.93583014 28.1875 54.8125 C28.88383545 55.16965088 29.5801709 55.52680176 30.29760742 55.89477539 C32.43463623 57.00026891 34.56225715 58.12203618 36.6875 59.25 C37.64197021 59.75225098 37.64197021 59.75225098 38.61572266 60.26464844 C47.07433056 64.75526977 54.469121 69.95010968 61.6875 76.25 C62.34363281 76.78496094 62.99976563 77.31992187 63.67578125 77.87109375 C70.36342525 83.34280248 75.58700936 90.02891604 80.875 96.8125 C81.29112549 97.34238525 81.70725098 97.87227051 82.13598633 98.41821289 C85.05116821 102.20882476 87.37264972 106.08232659 89.6875 110.25 C90.2753125 111.20261719 90.863125 112.15523438 91.46875 113.13671875 C98.28674555 124.2469524 103.52100338 136.67384256 101 149.9375 C99.09066598 157.06568036 95.75875255 162.91183942 90.6875 168.25 C90.0275 168.25 89.3675 168.25 88.6875 168.25 C88.6875 168.91 88.6875 169.57 88.6875 170.25 C86.94068707 171.23484108 85.1899149 172.21266187 83.4375 173.1875 C82.46296875 173.73277344 81.4884375 174.27804687 80.484375 174.83984375 C73.40866043 178.40734788 65.02989262 178.41809838 57.44921875 176.37890625 C42.28850099 170.50340572 36.78602764 159.53689717 29.9140625 145.671875 C22.79118157 131.55987616 12.11772312 122.62717094 -2.60546875 117.0625 C-18.58407766 112.26661161 -34.5028847 113.57169056 -49.3125 121.25 C-52.54339506 123.35535774 -55.43982024 125.6817468 -58.3125 128.25 C-58.95058594 128.806875 -59.58867187 129.36375 -60.24609375 129.9375 C-64.78650319 134.15568683 -67.56837267 138.73316069 -70.3125 144.25 C-70.68375 144.94480469 -71.055 145.63960937 -71.4375 146.35546875 C-78.01818043 158.86360031 -78.84302382 173.19363261 -75.41015625 186.8359375 C-70.3836153 202.16942604 -61.01998265 214.87031642 -46.61523438 222.49511719 C-31.97549439 229.88682104 -16.25647051 234.6614111 -0.59423828 239.35180664 C9.00910656 242.23789011 18.1871456 245.55406636 27.31445312 249.71899414 C29.3736662 250.65365867 31.45792875 251.53799919 33.57617188 252.32983398 C35.6875 253.25 35.6875 253.25 36.6875 255.25 C38.34904813 255.92932322 40.01683515 256.59341703 41.6875 257.25 C48.86589626 261.48393386 55.26972287 266.37281084 61.3359375 272.07421875 C63.71499894 274.33719322 63.71499894 274.33719322 66.58203125 276.50390625 C70.39139122 279.65883461 73.14611039 283.48932576 76 287.5 C76.56541504 288.2943042 77.13083008 289.0886084 77.71337891 289.90698242 C89.46175758 306.73587626 98.91440785 326.54727619 100.6875 347.25 C100.75694824 347.96494629 100.82639648 348.67989258 100.89794922 349.41650391 C103.42541178 376.77614783 98.27016148 403.31994414 84.6875 427.25 C84.13320313 428.23226563 83.57890625 429.21453125 83.0078125 430.2265625 C78.38390163 437.90358198 72.65983024 444.60506195 66.6875 451.25 C65.91792969 452.11625 65.14835938 452.9825 64.35546875 453.875 C50.74213653 468.34641279 32.09912706 479.67133612 12.6875 484.25 C12.71070313 485.04019531 12.73390625 485.83039063 12.7578125 486.64453125 C13.03011912 503.66369494 13.11664072 523.16065088 0.6875 536.25 C-7.70990565 544.06154014 -16.18949904 545.90677261 -27.515625 545.66796875 C-36.86002768 544.63931537 -44.80786479 540.56228445 -50.859375 533.42578125 C-59.14280153 522.33337097 -60.51715953 508.17860789 -60.375 494.75 C-60.37048828 493.92757813 -60.36597656 493.10515625 -60.36132812 492.2578125 C-60.34968489 490.25517604 -60.33175556 488.25257773 -60.3125 486.25 C-63.35370294 484.65992943 -66.47890151 483.32268493 -69.64111328 481.99316406 C-83.98752783 475.90680638 -96.44018319 468.32584782 -108.3125 458.25 C-108.86292969 457.78609863 -109.41335938 457.32219727 -109.98046875 456.84423828 C-116.71870182 451.09633341 -122.69240051 444.90941533 -128.3125 438.0625 C-128.84045166 437.42159424 -129.36840332 436.78068848 -129.91235352 436.12036133 C-133.20640876 431.98789599 -135.779941 427.77403223 -138.13671875 423.04174805 C-139.26280632 420.92230865 -139.26280632 420.92230865 -142.3125 420.25 C-141.9825 419.59 -141.6525 418.93 -141.3125 418.25 C-142.02551287 416.26167955 -142.8326827 414.30660372 -143.6875 412.375 C-148.00256091 402.56366039 -148.87746201 393.05330907 -145.37109375 382.71875 C-143.48437915 378.31873662 -141.22330793 374.06080704 -138.3125 370.25 C-137.6525 370.25 -136.9925 370.25 -136.3125 370.25 C-136.3125 369.59 -136.3125 368.93 -136.3125 368.25 C-129.93571997 362.74278088 -121.64282464 359.13053474 -113.125 358.875 C-103.04016334 359.86695115 -94.07818054 362.21575436 -87.3125 370.25 C-87.3125 370.91 -87.3125 371.57 -87.3125 372.25 C-86.6525 372.25 -85.9925 372.25 -85.3125 372.25 C-84.99611572 372.85360352 -84.67973145 373.45720703 -84.35375977 374.07910156 C-75.48844946 392.72435855 -75.48844946 392.72435855 -62.0625 407.92578125 C-61.485 408.36277344 -60.9075 408.79976562 -60.3125 409.25 C-60.3125 409.91 -60.3125 410.57 -60.3125 411.25 C-59.52746094 411.63865234 -59.52746094 411.63865234 -58.7265625 412.03515625 C-56.8798835 412.96447206 -55.04310055 413.91347704 -53.2109375 414.87109375 C-38.10983707 422.65602912 -22.57549339 426.85327775 -5.6875 421.625 C-0.19616317 419.42073099 4.83845301 416.63363042 9.6875 413.25 C10.37457031 412.77175781 11.06164062 412.29351563 11.76953125 411.80078125 C23.39025197 402.70132144 30.10489047 387.60298705 32.37109375 373.33203125 C33.95833483 357.87112738 32.27060711 343.43215592 22.75 330.6484375 C14.49330147 320.88784031 3.59207921 314.70809345 -8.3125 310.25 C-9.6325 310.25 -10.9525 310.25 -12.3125 310.25 C-12.6425 309.59 -12.9725 308.93 -13.3125 308.25 C-15.72956547 307.31331814 -18.11364227 306.48960245 -20.58203125 305.7109375 C-22.11687682 305.2119597 -23.65170694 304.71293439 -25.18652344 304.21386719 C-25.99343628 303.95456421 -26.80034912 303.69526123 -27.63171387 303.42810059 C-62.86307345 292.07989424 -95.81664908 279.31911064 -120.3125 250.25 C-121.199375 249.280625 -122.08625 248.31125 -123 247.3125 C-126.32826319 242.9048001 -128.78034184 238.14721959 -131.3125 233.25 C-132.07433594 231.83847656 -132.07433594 231.83847656 -132.8515625 230.3984375 C-148.73851303 200.17249572 -150.07425074 164.81522984 -140.42651367 132.49438477 C-138.07108942 125.07036958 -134.88360752 118.15931672 -131.3125 111.25 C-130.80203125 110.24710937 -130.2915625 109.24421875 -129.765625 108.2109375 C-115.28125879 81.60846293 -90.24805838 61.62408057 -61.66015625 52.0234375 C-59.21754801 51.35069855 -56.79814875 50.73595829 -54.3125 50.25 C-54.3846875 49.61835938 -54.456875 48.98671875 -54.53125 48.3359375 C-56.11854817 33.03614682 -56.59214621 18.23747503 -47.06640625 5.25 C-34.55846238 -9.01295604 -15.51155153 -10.79320886 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(536.3125,231.75)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FEFEFF",
    transform: "translate(522,68)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FEFEFE",
    transform: "translate(827,622)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FBFDFD",
    transform: "translate(903,466)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#FDFEFE",
    transform: "translate(41,436)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F7",
    transform: "translate(0,0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(471,282)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FEFFFE",
    transform: "translate(500,68)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFFFD",
    transform: "translate(474,926)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFEFE",
    transform: "translate(619,916)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FCFCFD",
    transform: "translate(196,787)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFEFE",
    transform: "translate(292,780)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FEFFFF",
    transform: "translate(482,766)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFE",
    transform: "translate(0,0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#F9FBFA",
    transform: "translate(146,726)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFEFE",
    transform: "translate(818,621)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FCFDFE",
    transform: "translate(801,563)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(124,531)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FCFEFF",
    transform: "translate(80,509)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FEFFFF",
    transform: "translate(866,498)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFD",
    transform: "translate(0,0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFE",
    transform: "translate(0,0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(532,469)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFFFE",
    transform: "translate(520,465)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF8FA",
    transform: "translate(0,0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFD",
    transform: "translate(0,0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFCFC",
    transform: "translate(0,0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFEFF",
    transform: "translate(554,363)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFE",
    transform: "translate(0,0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F7F7",
    transform: "translate(0,0)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#F6F8F7",
    transform: "translate(814,195)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F3F4F4",
    transform: "translate(0,0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFCFD",
    transform: "translate(612,149)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FEFEFF",
    transform: "translate(567,139)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFDFC",
    transform: "translate(410,80)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FEFEFD",
    transform: "translate(432,75)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FEFFFF",
    transform: "translate(495,68)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4F5F6",
    transform: "translate(0,0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFE",
    transform: "translate(0,0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFD",
    transform: "translate(0,0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFFFE",
    transform: "translate(0,0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFF",
    transform: "translate(0,0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFC",
    transform: "translate(0,0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFF",
    transform: "translate(0,0)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFB",
    transform: "translate(0,0)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFDFD",
    transform: "translate(0,0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFD",
    transform: "translate(0,0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFD",
    transform: "translate(0,0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFD",
    transform: "translate(0,0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFDFD",
    transform: "translate(0,0)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFCFD",
    transform: "translate(0,0)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFF",
    transform: "translate(0,0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFAFD",
    transform: "translate(0,0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFA",
    transform: "translate(0,0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFF",
    transform: "translate(0,0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FAFA",
    transform: "translate(0,0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFF",
    transform: "translate(0,0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFC",
    transform: "translate(0,0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFD",
    transform: "translate(0,0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFD",
    transform: "translate(0,0)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFD",
    transform: "translate(0,0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFCFE",
    transform: "translate(0,0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFC",
    transform: "translate(0,0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFF",
    transform: "translate(0,0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFBFA",
    transform: "translate(0,0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFD",
    transform: "translate(0,0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFE",
    transform: "translate(0,0)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9FB",
    transform: "translate(0,0)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFD",
    transform: "translate(0,0)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFC",
    transform: "translate(0,0)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFE",
    transform: "translate(0,0)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAF9",
    transform: "translate(0,0)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFE",
    transform: "translate(0,0)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFD",
    transform: "translate(0,0)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFD",
    transform: "translate(0,0)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFB",
    transform: "translate(0,0)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9FC",
    transform: "translate(0,0)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFD",
    transform: "translate(0,0)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFD",
    transform: "translate(0,0)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFB",
    transform: "translate(0,0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFC",
    transform: "translate(0,0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFE",
    transform: "translate(0,0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFE",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFE",
    transform: "translate(0,0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFC",
    transform: "translate(0,0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFB",
    transform: "translate(0,0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFB",
    transform: "translate(0,0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFE",
    transform: "translate(0,0)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFD",
    transform: "translate(0,0)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFD",
    transform: "translate(0,0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBF9",
    transform: "translate(0,0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFEFD",
    transform: "translate(0,0)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFC",
    transform: "translate(0,0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFB",
    transform: "translate(0,0)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF9FA",
    transform: "translate(0,0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFE",
    transform: "translate(0,0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFC",
    transform: "translate(0,0)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FBFA",
    transform: "translate(0,0)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFB",
    transform: "translate(0,0)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFC",
    transform: "translate(0,0)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFC",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFEFC",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFC",
    transform: "translate(0,0)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFF",
    transform: "translate(0,0)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFF",
    transform: "translate(0,0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFC",
    transform: "translate(0,0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF9FB",
    transform: "translate(0,0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFA",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFE",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFC",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFE",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFE",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFF",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFAF9",
    transform: "translate(0,0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFD",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFF",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFC",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFFFF",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFF",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFE",
    transform: "translate(0,0)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFE",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFF",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFF",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFD",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFC",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFC",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFD",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFD",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFD",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFD",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F1F4F2",
    transform: "translate(0,0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9FA",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFF",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFE",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFD",
    transform: "translate(0,0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFCFF",
    transform: "translate(0,0)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFF",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E7E8E7",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFFFE",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFBFD",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFE",
    transform: "translate(0,0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFF",
    transform: "translate(0,0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFD",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFE",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFCFE",
    transform: "translate(0,0)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFC",
    transform: "translate(0,0)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFF",
    transform: "translate(0,0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFB",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFD",
    transform: "translate(0,0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFD",
    transform: "translate(0,0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFC",
    transform: "translate(0,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFC",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFB",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFC",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ECEDEC",
    transform: "translate(0,0)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFC",
    transform: "translate(0,0)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFD",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFF",
    transform: "translate(0,0)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFDFF",
    transform: "translate(0,0)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFD",
    transform: "translate(0,0)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFE",
    transform: "translate(0,0)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFE",
    transform: "translate(0,0)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFEFC",
    transform: "translate(0,0)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFF",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFF",
    transform: "translate(0,0)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFEFC",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAFA",
    transform: "translate(0,0)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFF",
    transform: "translate(0,0)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F7F7",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFE",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFCFF",
    transform: "translate(0,0)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFD",
    transform: "translate(0,0)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F7F8",
    transform: "translate(0,0)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFB",
    transform: "translate(0,0)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F8",
    transform: "translate(0,0)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFB",
    transform: "translate(0,0)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFBFD",
    transform: "translate(0,0)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFE",
    transform: "translate(0,0)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFF",
    transform: "translate(0,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F7F8",
    transform: "translate(0,0)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFD",
    transform: "translate(0,0)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFAFE",
    transform: "translate(0,0)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFB",
    transform: "translate(0,0)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFA",
    transform: "translate(0,0)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F8FA",
    transform: "translate(0,0)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFBFB",
    transform: "translate(0,0)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF9FB",
    transform: "translate(0,0)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFFFD",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F9F8",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F5F6",
    transform: "translate(0,0)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFF",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FAFA",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4F5F3",
    transform: "translate(0,0)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFD",
    transform: "translate(0,0)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7FAF8",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFC",
    transform: "translate(0,0)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9F8",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F9F8",
    transform: "translate(0,0)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF9FA",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F7",
    transform: "translate(0,0)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFB",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFD",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FCFC",
    transform: "translate(0,0)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFBFB",
    transform: "translate(0,0)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F1F5F2",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F9F8",
    transform: "translate(0,0)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFF",
    transform: "translate(0,0)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F6F6",
    transform: "translate(0,0)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F9FA",
    transform: "translate(0,0)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F8F8",
    transform: "translate(0,0)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FBFB",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFBFA",
    transform: "translate(0,0)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F7FA",
    transform: "translate(0,0)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FAF8",
    transform: "translate(0,0)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9FB",
    transform: "translate(0,0)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F8F8",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F5F5",
    transform: "translate(0,0)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFD",
    transform: "translate(0,0)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFE",
    transform: "translate(0,0)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FAF8",
    transform: "translate(0,0)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FBF9",
    transform: "translate(0,0)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAFB",
    transform: "translate(0,0)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4F7F5",
    transform: "translate(0,0)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFCF8",
    transform: "translate(0,0)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FBF9",
    transform: "translate(0,0)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FAFC",
    transform: "translate(0,0)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFC",
    transform: "translate(0,0)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFE",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFB",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFC",
    transform: "translate(0,0)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFC",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFD",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFFFD",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFE",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFD",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFD",
    transform: "translate(0,0)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFE",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFF",
    transform: "translate(0,0)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSelected);
export default __webpack_public_path__ + "static/media/transaction_selected.8838c5e2b2f50d1782dee0cbb782966a.svg";
export { ForwardRef as ReactComponent };